export const ChargebacksDetailsTabs = {
	MerchantInformation: {
		name: "merchant-information",
		displayName: "Merchant Information",
	},
	ChargebacksReview: {
		name: "review",
		displayName: "Chargebacks Review",
	},
	Notes: {
		name: "notes",
		displayName: "Notes",
	},
	Attachments: {
		name: "attachments",
		displayName: "Attachments",
	},
};
